import { Grid } from '@mui/material';
import React from 'react';
import CountUp from 'react-countup';

const VisitorCounter = ({ statsData }) => {


    return (
        <>

            <Grid container>

                {statsData.map((stat, index) => (
                    <Grid xs={12} className='centerclass' sx={{ marginBottom: { xs: "2px", sm: "2px" } }} sm={12} md={3}>
                        <div key={index} style={{
                            backgroundColor: 'white',
                            padding: '30px',
                            borderRadius: '20px',
                            width: '150px',
                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                        }}>
                            <div style={{
                                fontSize: '36px',
                                color: '#31F711',
                                fontWeight: 'bold',
                                marginBottom: '10px'
                            }}>
                                <CountUp
                                    start={0}
                                    end={stat.value}
                                    duration={2.5}
                                    separator=","
                                    color="#31F711"
                                />
                            </div>
                            <div style={{
                                fontSize: '14px',
                                color: '#555',
                                textTransform: 'uppercase',
                                fontWeight: "bolder"
                            }}>{stat.label}</div>
                        </div>
                    </Grid>
                ))}
            </Grid >
        </>
    );
};

export default VisitorCounter;
